module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-08.ad8ae189.png";